module.exports = __webpack_public_path__ + "static/media/gaming.883b8d18.gif";